export default __webpack_public_path__ + "static/media/HelveticaNeueCyr-Heavy.dc8b4172.ttf";